import React from "react";
import { Container } from "react-bootstrap";
import NavBar from "./NavBar";

const Header = () => {
  return (
    <header>
      <Container
        className="d-flex flex-column justify-content-between"
        style={{ height: "100%" }}
      >
        <NavBar />
        <h1>Ahmed Ishmael</h1>
        <div id="header" className="shadowed px-5">
          <div
            id="header-txt"
            className="animate__animated animate__zoomIn animate__delay-1s"
          >
            <p id="header-txt1">
              I AM <br /> WEB DEVELOPER
            </p>
            <p id="header-txt2">Specialized in front end web development</p>
            <p>
              Have an experience in web designing and development <br />
              building high quality & responsive websites using HTML, CSS,
              Bootstrap ,Tailwind CSS, JavaScript and React JS.
            </p>
            <a href="Ahmed Ishmael CV.pdf" download>
              <button className="red-button px-3 py-2">Download CV</button>
            </a>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
